module.exports = "/assets/68701a6812c8ba40f649ae716900fce1.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/GL.png
// module id = 1409
// module chunks = 0